import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import {
  VueAxios
} from './axios'
import notification from 'ant-design-vue/es/notification'
import {
  ACCESS_TOKEN,
  ACCESS_VERSION_MESSAGE,
  ACCESS_CLOUD_TOKEN
} from '@/store/mutation-types'

// 创建 axios 实例
const service = axios.create({
  baseURL: '/api', // api base_url
  timeout: 50000 // 请求超时时间
})

const err = (error) => {
  if (error.response) {
    const data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      notification.error({
        message: '提示',
        description: data.message
      })
    }
    // 错误信息是9999的时候 要重新调接口获取版本权限
    console.log('error.response', error.response)
    // ||error.response.data.status === 9999
    if (error.response.status === 9999 || error.response.data.status === 9999) {
      store.dispatch('GetPermissions').then((res) => {
        console.log('GetPermissions9999', res)
      }).catch(reason => console.error('===GetPermissions==', reason))
    }
    // 之前是 401，现改为999
    if (error.response.status === 999 && !(data.result && data.result.token)) {
      notification.error({
        message: '提示',
        description: '登录超时，请重新登录'
      })
      if (token) {
        // store.dispatch('Logout').then(() => {
        //   setTimeout(() => {
        //     window.location.reload()
        //   }, 1500)
        // }).catch(reason => console.error("===Logout==", reason))
      }
    }
  }
  if (error.toString().indexOf('timeout') !== -1) {
    notification.error({
      message: '请求超时，请刷新页面稍后重试'
    })
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  const cloudToken = Vue.ls.get(ACCESS_CLOUD_TOKEN)
  const versionMessage = Vue.ls.get(ACCESS_VERSION_MESSAGE)
  if (token && !config.headers.token) {
    config.headers['token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  if (cloudToken) {
    config.headers['cloudToken'] = cloudToken // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  if (versionMessage) {
    config.headers['versionMessage'] = versionMessage // 让每个请求携带自定义 versionMessage 请根据实际情况自行修改
  }
  return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
  return response.data
}, err)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}